// extracted by mini-css-extract-plugin
module.exports = {"Container":"FormRecordPhone_Container__oAKyQ","Title":"FormRecordPhone_Title__Cs6n6","BoxInput":"FormRecordPhone_BoxInput___Ly7N"};